<script setup lang="ts">
import { defineProps } from "vue";

type Props = {
  termin: any;
};

defineProps<Props>();
</script>

<template>
  <div class="my-3 grid grid-cols-1 md:grid-cols-2 gap-[12.5px]">
    <!-- Block one -->
    <div
      class="flex gap-2 p-3 bg-white rounded-primary-radius shadow-[0px_1px_13px_rgba(57,56,64,0.1)]"
      :class="termin.workers?.length >= 8 ? 'items-start' : 'items-center'"
    >
      <div class="min-w-[44px] h-[44px] flex items-center justify-center">
        <img
          class="w-full h-full object-cover"
          src="@/assets/termin-workers-icon.svg"
          alt="Worker"
        />
      </div>
      <div class="flex flex-wrap items-start gap-2">
        <h3
          v-for="(worker, index) in termin.workers"
          :key="index"
          class="text-lg text-primary-text-color tracking-[0.01rem] font-medium"
        >
          {{ worker }}<span v-if="index < termin.workers.length - 1">,</span>
        </h3>
      </div>
    </div>
    <!-- Block two -->
    <div
      class="flex items-center gap-2 p-3 bg-white rounded-primary-radius shadow-[0px_1px_13px_rgba(57,56,64,0.1)]"
    >
      <div class="flex items-center justify-center">
        <img src="@/assets/termin-calendar-icon.svg" alt="Calendar" />
      </div>
      <h3
        class="text-lg text-primary-text-color tracking-[0.01rem] font-medium"
      >
        {{ new Date(termin.start).toLocaleDateString("DE") }} -
        {{ new Date(termin.end).toLocaleDateString("DE") }}
      </h3>
    </div>
  </div>
</template>
